import { render, staticRenderFns } from "./DeudaPorVendedor.vue?vue&type=template&id=55388a26&"
import script from "./DeudaPorVendedor.vue?vue&type=script&lang=js&"
export * from "./DeudaPorVendedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports